import { AmortizacionReadingDtoProps } from "api/DTOs/AmortizacionReadingDto"
import { AsientoContableSimpleReadingDtoProps } from "api/DTOs/AsientoContableSimpleReadingDto"
import { TFunction } from "i18next"

export const getDateDefault = (date: string | number) => {
  const d = new Date(date)
  const year = d.getFullYear()
  const month = (d.getMonth() + 1).toString().padStart(2, "0")
  return `${year}/${month}/01`
}

export const checkIfDateIsBefore = (rowData: AmortizacionReadingDtoProps) => {
  const date = getDateDefault(rowData?.fecha)
  const now = getDateDefault(Date.now())
  return new Date(date) < new Date(now)
}

export const getFechaEmisionStyles = (
  asientoContable: AsientoContableSimpleReadingDtoProps | null,
  inTime: boolean
) => {
  if (asientoContable) {
    return "td-checked"
  }
  if (inTime) {
    return "td-bold td-danger"
  }
  return ""
}

export interface DeleteModalState {
  show: boolean
  title: string
  text: string
  mode: number | null
  id: string | null | undefined
}

export const TIPO_IMPORTE: { [key: number]: string } = {
  1: "%",
  2: "€",
}

export const getTypeValueComision = (type: number, value: string | number) => {
  return `${value}${TIPO_IMPORTE[type]}`
}

export const PERIODO_AMORTIZACION = (t: TFunction) => {
  return {
    1: `${t("others.monthlyLabel")}`,
    2: `${t("others.annualLabel")}`,
  }
}

export const TIPO_PERIODO_AMORTIZACION = (t: TFunction) => {
  return {
    1: `${t("others.withOffLabel")}`,
    2: `${t("others.cuoteLabel")}`,
  }
}

export const TIPOS_AMORTIZACION = (t: TFunction) => {
  return {
    1: `${t("others.fixedLabel")}`,
    2: `${t("others.variableLabel")}`,
  }
}
